<div class="modals dropship-info" [class.modals-show]="isModalShow">
  <!-- Нова схема (картка #867): ТТН створюється до замовлення, тож внутрішнього номера (№ замовлення) у ній немає,
       а наклейку і реєстр клієнт завантажує у формі замість листа на dropmt@ukr.net -->
  <ng-container *ngIf="newScheme">
    <ul>
      <li>1. У вашому особистому кабінеті перевізника створіть ТТН (відправка: м. Київ, відділення НП №5; Делівері №23)
        і скачайте маркування 100 * 100 типу "зебра" та реєстр - у форматі PDF, PNG або JPG.</li>
      <li>2. Завантажте наклейку і реєстр тут, у формі оформлення замовлення (поля «Наклейка» і «Реєстр», до 5 МБ
        кожен файл), і відправте замовлення. Надсилати їх листом не потрібно - склад надрукує файли сам.</li>
      <li>3. Номер ТТН і кількість місць система розпізнає з наклейки сама - перевірте розпізнаний номер у формі, а після
        оформлення - в замовленнях: Меню - замовлення - графа номер декларації. Якщо номер не розпізнався, впишіть його
        вручну.
      </li>
    </ul>
    <b class="alert">Приклад:</b>
    <div class="row column pt5 pb5">
      <img src="/assets/images/drop1.png">
      <img src="/assets/images/photo_instructions2.jpg">
      <img src="/assets/images/photo_instructions.jpg">
      <img src="/assets/images/drop3.png">
      <img src="/assets/images/drop4.png">
    </div>
  </ng-container>
  <ng-container *ngIf="!newScheme">
  <ul>
    <li>1. У вашому особистому кабінеті перевізника створіть ТТН та обов’язково вкажіть внутрішній номер відправлення (№ замовлення) м. Київ, відділення відправки НП №5; Делівері №23.</li>
    <img src="assets/images/photo_instructions_dropship(1).jpg">
    <li>2. Створюєте один реєстр на ТТН-ки Нової Пошти, Делівері.
      <ul>
        <li>2.1. Скачайте в PDF форматі: маркування 100 * 100 типу "зебра" PDF і реєстр в альбомному форматі.</li>
        <li>2.2. Наклейки робляться у відповідності з кількістю місць. У разі, якщо ви не знаєте точну кількість місць
          для вашого замовлення, чекайте повідомлення з точною кількістю місць:
          <br>- у телеграм бот (треба бути підписаним на @MaslotochkacomBot). <br>- Меню, замовлення, колонка тип доставки.
          Це стосується лише замовлень, де кількість місць більше одного!
        </li>
      </ul>
    </li>
    <li>3. Відправляєте маркування і реєстр на
      <span class="alert">dropmt@ukr.net</span>. ВАЖЛИВО (!)В темі листа вказати (!): "Наклейка і № замовлення".
    </li>
    <li>4. ОБОВ‘ЯЗКОВО! Після оформлення замовлення прописати номер ТТН в замовленнях:
      Меню - замовлення - графа номер декларації - буде виділена рожевим кольором.
    </li>
  </ul>
  <b class="alert">Приклад:</b>
  <div class="row column pt5 pb5">
    <img src="/assets/images/drop1.png">
    <img src="/assets/images/photo_instructions2.jpg">
    <img src="/assets/images/photo_instructions.jpg">
    <img src="/assets/images/drop3.png">
    <img src="/assets/images/drop4.png">
  </div>
  </ng-container>
  <button class="button" (click)="closeModal()">Згоден</button>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground"></div>
